import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppState } from './app.service';
import { MenuComponent } from './components/menu';
import { LoaderIndicatorService } from './services/loader-indicator/loader-indicator.service';
import { TranslationService } from './services/translation/translation.service';
import { ToasterConfig } from 'angular2-toaster';
import { AuthenticationService } from './services/security/authentication.service';

/**
 * Application main component
 */
@Component({
    selector: 'app',
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './app.component.css',
        '../../node_modules/baron/baron.css',
        '../../node_modules/baron/skins/styles.css'
    ],
    entryComponents: [
        [MenuComponent]
    ],
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    /**
     * 'loading' variable for displaying Preloader icon while some of services works
     */
    public loading: boolean;

    /**
     * | Toaster configuration | Comment |
     * | --- | --- |
     * | timeout: 10000 | toast message would be visible for 10 seconds and then hide |
     * | mouseoverTimerStop: true | when user mouse over toast message it wouldn't hide even if 10 seconds left |
     * @type {ToasterConfig}
     */
    public toasterConfig: ToasterConfig = new ToasterConfig({
        timeout: 10000,
        mouseoverTimerStop: true
    });

    /**
     * The "constructor"
     * @param {AppState} appState - state
     * @param {TranslationService} translate - service with translations
     * @param {LoaderIndicatorService} loaderIndicatorService - service for Preloader
     * @param authenticationService
     */
    constructor(public appState: AppState,
                private translate: TranslationService,
                private loaderIndicatorService: LoaderIndicatorService,
                private authenticationService: AuthenticationService) {
    }

    /**
     * App component initialization, preloader hides after app initialized
     */
    public ngOnInit() {
        console.log('Initial App State', this.appState.state);
        this.loaderIndicatorService.subscribe(loading => {
            setTimeout(() => {
                this.loading = loading;
            });
        });
    }

    public isLoggedIn() {
        return this.authenticationService.isLoggedIn();
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts